import { Component } from '@angular/core';
import { MegamenuComponent } from '../../megamenu/megamenu.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { CompanyConfigService, CompanyConfig } from '../../../services/company-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cockroach-control',
  templateUrl: './cockroach-control.component.html',
  styleUrl: './cockroach-control.component.css',
  imports: [MegamenuComponent, FooterComponent, MatButtonModule, MatIconModule, CommonModule]
})
export class CockroachControlComponent {
  config: CompanyConfig;

  constructor(
    private companyConfig: CompanyConfigService,
    private router: Router
  ) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  navigateToContact() {
    this.router.navigate(['/contact']);
  }
}